var _linearGradient, _path, _path2, _g, _linearGradient2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 97,
    x2: 36,
    y2: -1,
    gradientTransform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#d8e1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#ebf0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#f9fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    stroke: "#7191a1",
    strokeWidth: 2,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 36.294,
    y1: 38.976,
    x2: 36.294,
    y2: 22.783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 36.294,
    y1: 39.476,
    x2: 36.294,
    y2: 22.283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.3 22.8c-3.8 0-6.9 3.6-6.9 8.1s3.1 8.1 6.9 8.1 6.9-3.6 6.9-8.1-3.1-8.1-6.9-8.1zm0 13.1c-2.1 0-3.9-2.2-3.9-5s1.7-5 3.9-5c2.1 0 3.9 2.2 3.9 5-.1 2.7-1.8 5-3.9 5z",
    fill: "url(#b)",
    stroke: "url(#c)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 20.75,
    y1: 38.976,
    x2: 20.75,
    y2: 22.783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 20.75,
    y1: 39.476,
    x2: 20.75,
    y2: 22.283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 37.4V24.3c0-.9-.7-1.5-1.5-1.5-.9 0-1.5.7-1.5 1.5v13.1c0 .9.7 1.5 1.5 1.5.8.1 1.5-.6 1.5-1.5z",
    fill: "url(#d)",
    stroke: "url(#e)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 20.75,
    y1: 62.649,
    x2: 20.75,
    y2: 46.457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 20.75,
    y1: 63.149,
    x2: 20.75,
    y2: 45.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 46.5c-3.8 0-6.9 3.6-6.9 8.1s3.1 8.1 6.9 8.1 6.9-3.6 6.9-8.1c.1-4.5-3-8.1-6.9-8.1zm0 13.1c-2.1 0-3.9-2.2-3.9-5s1.7-5 3.9-5 3.9 2.2 3.9 5c0 2.7-1.7 5-3.9 5z",
    fill: "url(#f)",
    stroke: "url(#g)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 36.294,
    y1: 62.649,
    x2: 36.294,
    y2: 46.457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 36.294,
    y1: 63.149,
    x2: 36.294,
    y2: 45.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 61.1V48c0-.9-.7-1.5-1.5-1.5-.9 0-1.5.7-1.5 1.5v13.1c0 .9.7 1.5 1.5 1.5s1.5-.6 1.5-1.5z",
    fill: "url(#h)",
    stroke: "url(#i)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 52.251,
    y1: 40.11,
    x2: 52.251,
    y2: 23.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 52.251,
    y1: 40.61,
    x2: 52.251,
    y2: 23.418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.8 38.6V25.5c0-.9-.7-1.5-1.5-1.5-.9 0-1.5.7-1.5 1.5v13.1c0 .9.7 1.5 1.5 1.5s1.5-.7 1.5-1.5z",
    fill: "url(#j)",
    stroke: "url(#k)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 52.251,
    y1: 63.783,
    x2: 52.251,
    y2: 47.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 52.251,
    y1: 64.283,
    x2: 52.251,
    y2: 47.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#869ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#8399a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#7b929e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6d8694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#5a7785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#426373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#416271"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3 47.6c-3.8 0-6.9 3.6-6.9 8.1s3.1 8.1 6.9 8.1 6.9-3.6 6.9-8.1-3.1-8.1-6.9-8.1zm0 13.1c-2.1 0-3.9-2.2-3.9-5s1.7-5 3.9-5 3.9 2.2 3.9 5c-.1 2.8-1.8 5-3.9 5z",
    fill: "url(#l)",
    stroke: "url(#m)",
    strokeMiterlimit: 10
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 45.037,
    y1: 25.813,
    x2: 58.537,
    y2: 12.313,
    gradientTransform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fafbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#edf1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#dde5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#c7d3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#adbdc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92a5b0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fill: "url(#n)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    stroke: "#7191a1",
    strokeWidth: 2,
    strokeLinejoin: "bevel",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 71.5h8c1.6 0 2.8.1 3.5.2s1.5.4 2.1.8 1.1 1 1.5 1.7.6 1.5.6 2.3c0 .9-.3 1.8-.8 2.6s-1.2 1.4-2.1 1.8c1.2.4 2.2 1 2.8 1.8s1 1.9 1 3c0 .9-.2 1.8-.6 2.7s-1 1.5-1.7 2.1c-.7.5-1.6.8-2.7 1-.7.1-2.3.1-4.9.1H14V71.5zm4.1 3.3v4.6h2.7c1.6 0 2.6 0 2.9-.1.7-.1 1.2-.3 1.6-.7s.6-.9.6-1.6c0-.6-.2-1.1-.5-1.5s-.9-.6-1.5-.7c-.4 0-1.6-.1-3.5-.1h-2.3zm0 8v5.4h3.7c1.5 0 2.4 0 2.8-.1.6-.1 1.1-.4 1.5-.8.4-.4.6-1 .6-1.7 0-.6-.1-1.1-.4-1.5-.3-.4-.7-.7-1.3-.9-.6-.2-1.7-.3-3.6-.3h-3.3zm16 8.7v-20h4v20h-4zm8 0v-20H46l8.2 13.4V71.5H58v20h-4.1l-8.1-13.1v13.1h-3.7z",
    fill: "#4c6c7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.2d78525f549178a726521c46d02c559a.svg";
export { ForwardRef as ReactComponent };